import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteCustomerSchedulePakageApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteCustomerSchedule = createAsyncThunk('deleteCustomerSchedule', async (payload) => {
  return await deleteCustomerSchedulePakageApi(payload);
});

const deleteCustomerScheduleSlice = createSlice({
  name: 'deleteCustomerSchedule', // Unique Name
  initialState,
  reducers: {
    deleteCustomerScheduleReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCustomerSchedule.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteCustomerSchedule.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteCustomerSchedule.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteCustomerScheduleReset } = deleteCustomerScheduleSlice.actions;

export default deleteCustomerScheduleSlice.reducer;
